import PropTypes from 'prop-types';
import { Schema } from 'rsuite';
import {
  InventoryItemType,
  InventoryPackageType,
  IventoryPackageItemType
} from '../../../interfaces/inventory';
import { OptionType } from '../../../interfaces';
import {
  ItemType,
  PackageType
} from '../../../constants/inventory/InventoryTypes';
import { parseInt } from '../../../helpers/utils';

const { NumberType, ArrayType, StringType } = Schema.Types;

export const defualtFormValue = {
  name: '',
  description: '',
  price: '',
  points: '',
  weight: '',
  minCount: '',
  maxCount: '',
  photo: null,
  locationId: null,
  tagOptions: [],
  stoplight: 0
};

export const defaultPackageItemValue = {
  item: null,
  location: null,
  zone: null,
  quantity: 1
};

export const FormPropTypes = {
  item: PropTypes.oneOfType([InventoryItemType, InventoryPackageType]),
  tagOptions: PropTypes.arrayOf(OptionType).isRequired,
  itemOptions: PropTypes.arrayOf(OptionType),
  locationOptions: PropTypes.arrayOf(OptionType),
  zonesByLocationOptions: PropTypes.shape({}),
  packageItems: PropTypes.arrayOf(IventoryPackageItemType),
  packageActiveReservationOrderItemsCount: PropTypes.number,
  type: PropTypes.oneOf([ItemType, PackageType]).isRequired,
  isSaving: PropTypes.bool.isRequired,
  isSaved: PropTypes.bool.isRequired,
  isFetchingPackageItems: PropTypes.bool.isRequired,
  isFetchedPackageItems: PropTypes.bool,
  onInit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onResetPackageItems: PropTypes.func.isRequired,
  onDeletePackageItem: PropTypes.func.isRequired,
  onUndoDeletePackageItem: PropTypes.func.isRequired,
  onIncrementQtyPackageItem: PropTypes.func.isRequired,
  onDecrementQtyPackageItem: PropTypes.func.isRequired,
  onAddPackageItem: PropTypes.func
};

export const FormDefaultProps = {
  item: null,
  itemOptions: [],
  packageItems: [],
  packageActiveReservationOrderItemsCount: 0,
  locationOptions: [],
  zonesByLocationOptions: null,
  isFetchedPackageItems: false,
  onAddPackageItem: () => {}
};

export const createModelSchema = (formValue, isPackage) => {
  const model = {
    name: StringType()
      .isRequired('This field is required')
      .addRule(
        value => !/<[a-z][\s\S]*>/i.test(value),
        'HTML tags are not allowed'
      ),
    description: StringType().addRule(
      value => !/<[a-z][\s\S]*>/i.test(value),
      'HTML tags are not allowed'
    ),
    price: NumberType().addRule(
      value => /^\d*(\.\d{0,2})?$/.test(value),
      'Price must be 2 decimal point only'
    ),
    points: NumberType().addRule(
      value => /^(\.)?\d*$/.test(value),
      'No decimal value allowed.'
    ),
    minCount: NumberType(),
    maxCount: NumberType().addRule((value, { minCount }) => {
      if (!minCount) return true;
      return parseInt(value) >= parseInt(minCount);
    }, 'Max Count should be greater than or equal to Min Count'),
    tags: ArrayType()
  };

  if (formValue.minCount && !formValue.maxCount) {
    model.maxCount.isRequired(
      'Max Count is required when Min Count is provided'
    );
  }

  const extraFields = isPackage
    ? { locationId: NumberType().isRequired('This field is required') }
    : { stoplight: NumberType().range(0, 3, 'Values must 0 - 3') };

  return Schema.Model({ ...model, ...extraFields });
};
